import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IOcbPgpKey } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-pgp-key-picker',
    templateUrl: './pgp-key-picker.component.html',
    styleUrls: ['./pgp-key-picker.component.scss'],
})
export class PgpKeyPickerComponent implements AfterViewInit {

    @Input()
    public keys: IOcbPgpKey[];

    @Input()
    public isDisabled: boolean;

    @Input()
    public isRequired: boolean = false;

    @Input()
    public selectedItem?: IOcbPgpKey;

    @Output()
    public selectedItemChange = new EventEmitter<IOcbPgpKey>();

    @ViewChild('selectBox')
    public selectBox: DxSelectBoxComponent;

    public ngAfterViewInit(): void {
        if (this.selectedItem) {
            this.selectBox.value = this.selectedItem.id;
        }
    }

    public onSelectedItemChange($event: IOcbPgpKey): void {
        if ($event == null && this.isRequired) {
            return;
        }
        this.selectedItemChange.emit($event);
    }
}
